<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12">
        <v-banner icon="history">Payment History</v-banner>
      </v-col>

      <v-col cols="12" sm="12">
        <v-btn
          block
          outlined
          color="blue darken-2"
          large
          :loading="loadingPayments"
          @click.stop="fetchPaymentHistory"
        >
          <v-icon class="mr-2">refresh</v-icon>Refresh
        </v-btn>
      </v-col>

      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :loading="loadingPayments"
          loading-text="Loading Your Payment History..."
          :items="payments"
          class="elevation-0"
          multi-sort
          show-expand
          single-expand
          :items-per-page="15"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-2">
              <h4 class="px-4 pt-2">Payment Method</h4>
              <v-simple-table
                style="text-transform: capitalize"
                class="expansionColour elevation-0"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Type</th>
                      <th class="text-left">Last 4 Digits</th>
                      <th class="text-left">Expiry</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ item.payment_method_details.card.network }}</td>
                      <td>{{ item.payment_method_details.card.last4 }}</td>
                      <td>
                        {{
                          `${item.payment_method_details.card.exp_month}/${item.payment_method_details.card.exp_year}`
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <h4 class="px-4 pt-2 mt-4">Refunds</h4>
              <v-data-table
                :headers="refundsHeaders"
                :items="item.refunds.data"
                class="expansionColour elevation-0"
                hide-default-footer
              >
                <template v-slot:no-data> No Refunds Found </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";

export default {
  data: () => {
    return {
      loadingPayments: false,
      headers: [
        { text: "Payment Date", value: "timestampDisplay", sortable: true },
        { text: "Amount Paid", value: "amountPaidDisplay", sortable: true },
        {
          text: "Original Payment",
          value: "amountOriginalDisplay",
          sortable: true,
        },
        {
          text: "Refunded Total",
          value: "amountRefundDisplay",
          sortable: true,
        },

        { text: "Payment Reference", value: "id", sortable: false },
      ],

      refundsHeaders: [
        { text: "Refund Date", value: "timestampDisplay", sortable: true },
        { text: "Refund Amount", value: "amountRefundDisplay", sortable: true },
      ],
      payments: [],
    };
  },

  computed: {},

  async activated() {
    this.fetchPaymentHistory();
  },

  methods: {
    ...mapActions(["paymentsHistory"]),

    async fetchPaymentHistory() {
      this.loadingPayments = true;
      this.payments = [];

      let params = {
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        userId: this.$store.getters.retrieveUser.userNum,
      };

      let paymentResponse = await this.paymentsHistory(params);

      console.log("-- Payment Response");
      console.log(paymentResponse);

      if (paymentResponse.success) {
        paymentResponse.sources.forEach((payment) => {
          payment.amountPaidDisplay =
            "£" + ((payment.amount - payment.amount_refunded) / 100).toFixed(2);

          payment.amountOriginalDisplay =
            "£" + (payment.amount / 100).toFixed(2);
          payment.amountRefundDisplay =
            "£" + (payment.amount_refunded / 100).toFixed(2);

          payment.statusDisplay = payment.status;

          payment.timestampDisplay = moment
            .unix(payment.created)
            .format("HH:mm:ss dddd, Do MMMM YYYY");

          payment.refunds.data.forEach((refund) => {
            refund.amountRefundDisplay = "£" + (refund.amount / 100).toFixed(2);

            refund.timestampDisplay = moment
              .unix(refund.created)
              .format("HH:mm:ss dddd, Do MMMM YYYY");
          });
        });

        this.payments = paymentResponse.sources;
      }

      this.loadingPayments = false;
    },
  },
};
</script>

<style lang="sass">
.theme--light .v-data-table tbody tr.v-data-table__expanded__content
  box-shadow: none
  background: #f3f4f7

.theme--light .expansionColour, .theme--light .expansionColour table th, .theme--light .expansionColour table td
  background: #f3f4f7 !important

.theme--dark .v-data-table tbody tr.v-data-table__expanded__content
  box-shadow: none
  background: #1b1b1b

.theme--dark .expansionColour, .theme--dark .expansionColour table th, .theme--dark .expansionColour table td
  background: #1b1b1b !important
</style>